
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum MailTemplateType {
	None = 0,
	SettlementSend = 1,
	SettlementConfirmed = 2,
	SettlementReminder = 3,
	NewOrderWarning = 4,
	NewOrderCancellation = 5,
	SettlementComplete = 6,
	RegistrarManagementRequest = 7,
	DomainPurchaseDk = 8,
	DomainPurchaseInternational = 9
}
export namespace MailTemplateType {
	export function getKeys(): Map<MailTemplateType, string> {
		return new Map([[0, 'None'], [1, 'SettlementSend'], [2, 'SettlementConfirmed'], [3, 'SettlementReminder'], [4, 'NewOrderWarning'], [5, 'NewOrderCancellation'], [6, 'SettlementComplete'], [7, 'RegistrarManagementRequest'], [8, 'DomainPurchaseDk'], [9, 'DomainPurchaseInternational']]);
	}
}
